/*
 * @Author: 李旭
 * @Date: 2021-12-06 16:54:50
 * @LastEditTime: 2021-12-07 16:48:11
 * @LastEditors: 李旭
 * @Description:
 * @FilePath: \ems-web-ant5.0\src\models\userManage.js
 *
 */

import { useState, useCallback, useEffect } from 'react';
export default () => {
  const [tableData, setTableData] = useState({
    list: [],
    pageNum: 0,
    pageSize: 0,
    total: 0,
  });
  const [params, setParams] = useState({});
  const [roleAssign, setRoleassign] = useState({ assign: [], unassign: [] });
  const [targetKeys, setTargetKeys] = useState([]);
  const handleTableData = useCallback((data) => {
    setTableData(data);
  }, []);
  const handleParams = useCallback((params) => {
    setParams(params);
  }, []);
  const handleAssign = useCallback((param) => {
    setRoleassign(param);
  }, []);
  const handleTargetKeys = useCallback((data) => {
    setTargetKeys(data);
  });
  return {
    tableData,
    handleTableData,
    handleParams,
    params,
    roleAssign,
    handleAssign,
    targetKeys,
    handleTargetKeys,
  };
};
